import { normalizeStr } from './formatters';
export const getEmployeeSearch = (input) => {
    const name = normalizeStr(input);
    const snils = name
        .split('')
        .map((el) => (isNaN(parseInt(el)) ? '' : el))
        .join('');
    const type = snils.length > 0 ? 'snils' : 'name';
    return {
        value: type === 'snils' ? snils : name,
        type,
    };
};
